import React from 'react'
import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert, { AlertProps, Color } from '@material-ui/lab/Alert'
import useSnackbar from './useSnackbar'

let Alert = (props: AlertProps) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}

type MySnackbarViewType = ReturnType<typeof useSnackbar> & { message: string; type: Color }
export let MySnackbarView = (props: MySnackbarViewType) => {
    const { handleClose, open, message, type } = props

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
        >
            <Alert onClose={handleClose} severity={type}>
                {message}
            </Alert>
        </Snackbar>
    )
}

let MySnackbar = () => {
    const snackbar = useSnackbar()
    return <MySnackbarView {...snackbar} message={' This is a success message!'} type="success" />
}
export default MySnackbar
